// extracted by mini-css-extract-plugin
module.exports = {"content":"order_content__3pMWL","actions":"order_actions__1maXV","settings":"order_settings__1PTpY","status":"order_status__ozfBM","status-appear":"order_status-appear__1U2gP"};